import { Tooltip } from 'react-tippy'

import 'react-tippy/dist/tippy.css'
import styled from 'styled-components'

import { fonts, palette } from '../../styles/variables'
import eyeIcon from '../../styles/assets/eye.svg'
import eyeHideIcon from '../../styles/assets/eye_hide.svg'
import { translate } from '../../utils/translation'

const EyeIcon = styled.img(() => ({
  width: 24,
  height: 24,
  cursor: 'pointer',
}))

const MessageBox = styled.span({
  fontFamily: fonts.primary,
  textAlign: 'center',
  color: palette.white,
  fontSize: '13px',
  whiteSpace: 'pre-wrap',
})

export default ({ show, toggle, ...rest }) => {
  return (
    <Tooltip
      arrow
      place="top"
      boundary="viewport"
      html={
        <MessageBox>
          {translate(show ? 'hide_toggle' : 'show_toggle')}
        </MessageBox>
      }
      popperOptions={{
        modifiers: {
          preventOverflow: {
            enabled: false,
          },
          hide: {
            enabled: false,
          },
        },
      }}
      {...rest}
    >
      <EyeIcon
        data-testid="show-password-eye"
        src={show ? eyeHideIcon : eyeIcon}
        alt="Show/Hide"
        onClick={toggle}
      />
    </Tooltip>
  )
}
